import { component } from 'picoapp';
import Drawer from 'utils/drawer';

export default component(async (node) => {
  const articleContent = node.querySelector('[data-article-content]');
  const productFeeds = node.querySelectorAll('[data-product-feed]');

  const initIframes = () => {
    const iframes = articleContent.querySelectorAll('iframe');

    iframes.forEach((iframe) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('aspect-ratio', 'aspect-ratio--16/9', 'bg-background');

      iframe.parentElement.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
    });
  };

  const initProductFeeds = () => {
    productFeeds.forEach((feed) => {
      const drawerElement = feed.querySelector<HTMLElement>('[data-product-feed-drawer]');
      const drawerBtn = feed.querySelector('[data-product-feed-drawer-btn]');
      const drawerCloseBtn = feed.querySelector('[data-product-feed-drawer-close-btn]');
      const image = feed.querySelector('[data-image]');

      if (!drawerElement || !drawerBtn) {
        return;
      }

      document.body.appendChild(drawerElement);
      const drawer = Drawer(drawerElement);

      drawerBtn.addEventListener('click', () => drawer.open());
      drawerCloseBtn.addEventListener('click', () => drawer.close());
      image.addEventListener('click', () => drawer.open());
    });
  };

  const init = () => {
    initIframes();
    initProductFeeds();
  };

  init();
});
